// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__centeredDialog___qQr6o {
  top: 50%;
  transform: translateY(-50%) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/ZeroQuantityModal/styles.less"],"names":[],"mappings":"AAAA;EACE,QAAA;EACA,sCAAA;AACF","sourcesContent":[".centeredDialog {\n  top: 50%;\n  transform: translateY(-50%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centeredDialog": `styles__centeredDialog___qQr6o`
};
export default ___CSS_LOADER_EXPORT___;
